/**
 * Social Share Functions
 */

// Initialize share functionality when DOM is ready
document.addEventListener("DOMContentLoaded", () => {
  initializeShareButtons();
});

function initializeShareButtons() {
  // Facebook share buttons
  const facebookButtons = document.querySelectorAll(".facebook-btn");
  if (facebookButtons.length > 0) {
    facebookButtons.forEach((button) => {
      button.addEventListener("click", function (e) {
        e.preventDefault();
        shareToFacebook(this);
      });
    });
  }

  // Pinterest share buttons
  const pinterestButtons = document.querySelectorAll(".pinterest-btn");
  if (pinterestButtons.length > 0) {
    pinterestButtons.forEach((button) => {
      button.addEventListener("click", function (e) {
        e.preventDefault();
        shareToPinterest(this);
      });
    });
  }

  // Copy link buttons
  const copyButtons = document.querySelectorAll(".copy-link-btn");
  if (copyButtons.length > 0) {
    copyButtons.forEach((button) => {
      button.addEventListener("click", function (e) {
        e.preventDefault();
        const url = this.getAttribute("data-share-url");
        if (url) {
          copyToClipboard(url);
        }
      });
    });
  }

  // Print buttons
  const printButtons = document.querySelectorAll(".print-btn");
  if (printButtons.length > 0) {
    printButtons.forEach((button) => {
      button.addEventListener("click", (e) => {
        e.preventDefault();
        window.print();
      });
    });
  }
}

function shareToFacebook(element) {
  try {
    const url = element.getAttribute("data-share-url");
    const quote = element.getAttribute("data-quote");

    if (!url) {
      console.error("Facebook share: URL is missing");
      return;
    }

    const facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}&quote=${encodeURIComponent(quote || "")}`;

    openShareWindow(facebookUrl, "Facebook Share", 600, 400);
  } catch (error) {
    console.error("Error sharing to Facebook:", error);
  }
}

function shareToPinterest(element) {
  try {
    const url = element.getAttribute("data-share-url");
    const media = element.getAttribute("data-media");
    const description = element.getAttribute("data-description");

    if (!url || !media) {
      console.error("Pinterest share: URL or media is missing");
      return;
    }

    const pinterestUrl = `https://pinterest.com/pin/create/button/?url=${encodeURIComponent(url)}&media=${encodeURIComponent(media)}&description=${encodeURIComponent(description || "")}`;

    openShareWindow(pinterestUrl, "Pinterest Share", 750, 550);
  } catch (error) {
    console.error("Error sharing to Pinterest:", error);
  }
}

function openShareWindow(url, title, width, height) {
  try {
    const left = (screen.width - width) / 2;
    const top = (screen.height - height) / 2;
    const params = `width=${width},height=${height},left=${left},top=${top},toolbar=0,menubar=0,location=0,status=0,scrollbars=1,resizable=1`;

    window.open(url, title, params);
  } catch (error) {
    console.error("Error opening share window:", error);
  }
}

function copyToClipboard(text) {
  if (!text) {
    console.error("Copy to clipboard: No text provided");
    return;
  }

  // Try modern clipboard API first
  if (navigator.clipboard && window.isSecureContext) {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        showCopyNotification("Link copied!");
      })
      .catch((err) => {
        console.error("Clipboard API failed:", err);
        fallbackCopyToClipboard(text);
      });
  } else {
    fallbackCopyToClipboard(text);
  }
}

function fallbackCopyToClipboard(text) {
  const textArea = document.createElement("textarea");
  textArea.value = text;
  textArea.style.cssText = "position:fixed;left:-9999px;top:0;";
  document.body.appendChild(textArea);
  textArea.focus();
  textArea.select();

  try {
    const successful = document.execCommand("copy");
    showCopyNotification(
      successful ? "Link copied!" : "Failed to copy",
      successful ? "success" : "error",
    );
  } catch (err) {
    console.error("execCommand failed:", err);
    showCopyNotification("Failed to copy", "error");
  } finally {
    document.body.removeChild(textArea);
  }
}

function showCopyNotification(message, type = "success") {
  // Remove any existing notification
  const existing = document.querySelector(".copy-notification");
  if (existing) {
    existing.remove();
  }

  // Create notification
  const notification = document.createElement("div");
  notification.className = `copy-notification copy-notification--${type}`;
  notification.innerHTML = `
    <span class="copy-notification__icon">${type === "success" ? "✓" : "✕"}</span>
    <span class="copy-notification__text">${message}</span>
  `;

  document.body.appendChild(notification);

  // Force reflow to enable transition
  notification.offsetHeight;

  // Show notification
  requestAnimationFrame(() => {
    notification.classList.add("copy-notification--show");
  });

  // Hide and remove after delay
  setTimeout(() => {
    notification.classList.remove("copy-notification--show");
    setTimeout(() => {
      if (notification.parentNode) {
        notification.remove();
      }
    }, 300);
  }, 2500);
}

export {
  initializeShareButtons,
  shareToFacebook,
  shareToPinterest,
  openShareWindow,
  copyToClipboard,
  fallbackCopyToClipboard,
  showCopyNotification,
};
